import { useLocaleContext } from '../../i18n';
import BaseSlider from './BaseSlider';

interface Props {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  zoneColor?: string;
}

export default function WeightSlider({ value, onChange, disabled, zoneColor }: Props) {
  const { locale } = useLocaleContext();

  return (
    <BaseSlider
      label={locale.settings.cyclist.weight}
      value={value}
      onChange={onChange}
      min={40}
      max={150}
      step={0.5}
      unit="kg"
      disabled={disabled}
      zoneColor={zoneColor}
    />
  );
}
